<template>
  <div class="kpt-user-panel-dropdown">
    <header class="level" style="margin-bottom: 8px;">
      <div class="level-left">
        <div class="level-item">
          <p><strong>{{user.accountName}}</strong></p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <a @click="signout">Sign Out</a>
        </div>
      </div>
    </header>
    <div class="kpt-user-panel-details">
      <b-tabs v-model="activeTab" class="has-hidden-tabs has-no-padding">
        <b-tab-item label="Home">
          <div class="kpt-user-panel-content">
            <h6 class="is-size-7 mb-0">{{ user.roleName }}</h6>
            <h4><strong>{{user.firstName}} {{user.lastName}}</strong></h4>
            <h6>{{user.email}}</h6>
          </div>
          <div class="kpt-user-panel-menu">
            <div class="level" @click="activeTabClick(1)">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'cogs']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>Portal Settings</h5></div>
              </div>
              <div class="level-right">
                <div class="level-item"><font-awesome-icon :icon="['far', 'chevron-right']" size="lg"></font-awesome-icon></div>
              </div>
            </div>
            <div class="level" @click="activeTabClick(2)">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'code']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>API Clients</h5></div>
              </div>
              <div class="level-right">
                <div class="level-item"><font-awesome-icon :icon="['far', 'chevron-right']" size="lg"></font-awesome-icon></div>
              </div>
            </div>
            <a class="level" :href="`${appConfig.authDomain}/account/changepassword?ref=portal`" target="_self" v-if="user.loginType == 'Local'">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'key']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>Password Management</h5></div>
              </div>
              <div class="level-right">
                <div class="level-item"><font-awesome-icon :icon="['far', 'external-link-alt']" size="lg"></font-awesome-icon></div>
              </div>
            </a>
            <router-link to="/health" class="level" v-if="$hasRole('Super User')">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'heartbeat']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>Application Health</h5></div>
              </div>
            </router-link>
          </div>
        </b-tab-item>
        <b-tab-item label="Settings">
          <div class="kpt-user-panel-menu">
            <div class="level" @click="activeTab = 0">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'chevron-left']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>Back</h5></div>
              </div>
            </div>
          </div>
          <div class="kpt-user-panel-content">
            <b-collapse :open="false">
              <div class="level" slot="trigger">
                <div class="level-left">
                  <div class="level-item"><label class="label">Local Cache</label></div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <font-awesome-icon :icon="['far', 'question-circle']"></font-awesome-icon>
                  </div>
                </div>
              </div>
              <b-message>
                Cached browser data enables a quick and pleasant experience across the portal. In the event you see anomalies on any of the list or detail pages, you can clear the cache to reset them back to normal.
              </b-message>
            </b-collapse>
            <div class="kpt-clear-cache buttons">
              <b-button type="is-primary" @click="clearAccountCache" size="is-small">Clear Account Cache</b-button>
              <b-button type="is-primary" @click="clearSearchCache" size="is-small">Clear Search History</b-button>
            </div>
            <b-collapse :open="false">
              <div class="level" slot="trigger">
                <div class="level-left">
                  <div class="level-item"><label class="label">Entity Detail Pane</label></div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <font-awesome-icon :icon="['far', 'question-circle']"></font-awesome-icon>
                  </div>
                </div>
              </div>
              <b-message>
                Compact detail pane will leave space on the left side of the screen to select different entities from a list, while full screen panes will take up the full width of the screen (minus the menu).
              </b-message>
            </b-collapse>
            <div style="margin-top: 8px;">
              <b-radio v-model="expandDetailPane" name="detailPane" :native-value="true">
                Full Width
              </b-radio>
              <b-radio v-model="expandDetailPane" name="detailPane" :native-value="false">
                Compact
              </b-radio>
            </div>
            <br>
            <restricted-wrapper label="Kymeta Admin" type="is-warning" v-if="$hasRole('Super User,Kymeta Admin')">
              <b-field label="Show Detailed Errors">
                <b-switch v-model="detailedErrors">
                  {{ detailedErrors ? 'Yes' : 'No' }}
                </b-switch>
              </b-field>
            </restricted-wrapper>
          </div>
        </b-tab-item>
        <b-tab-item label="API Clients">
          <div class="kpt-user-panel-menu">
            <div class="level" @click="activeTab = 0">
              <div class="level-left">
                <div class="level-item"><font-awesome-icon :icon="['far', 'chevron-left']" size="lg"></font-awesome-icon></div>
                <div class="level-item"><h5>Back</h5></div>
              </div>
            </div>
          </div>
          <div class="kpt-user-panel-content">
            <api-client-management v-if="activeTab == 2"></api-client-management>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
    <footer class="kpt-user-panel-footer">

    </footer>
  </div>
</template>
<script>
import RestrictedWrapper from '../shared/RestrictedWrapperComponent.vue';
import ApiClientManagement from './userdropdown/ApiClientManagement.vue';

export default {
  data() {
    return {
      activeTab: 0,
      clearedListSettings: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    detailedErrors: {
      get() {
        return this.$store.state.user.settings.detailedErrors;
      },
      set(newValue) {
        this.$store.commit('setDetailedErrors', newValue);
        this.$store.dispatch('updateSetting', { key: 'detailedErrors', value: newValue });
      }
    },
    expandDetailPane: {
      get() {
        return this.$store.state.user.settings.detailFullWidth;
      },
      set(newValue) {
        // KyAnalytics client plugin, event tracker
        this.$kya.event('system', 'detailPane', 'User detail pane width changed', { key: 'detailFullWidth', value: newValue });
        this.$store.commit('setExpandDetailPane', newValue);
        this.$store.dispatch('updateSetting', { key: 'detailFullWidth', value: newValue });
      }
    },
    appConfig() {
      return this.$store.state.appConfig;
    }
  },
  components: {
    RestrictedWrapper,
    ApiClientManagement
  },
  methods: {
    signout() {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('userPane', 'signOut', 'User signed out')
      this.$auth.signOut();
    },
    openUserContextPane() {
      this.$store.commit('setContextPane', 'user');
      this.$emit('closeuserpanel');
    },
    clearListSettings(table) {
      const listSettings = this.$store.state.user.settings.userListSettings;
      const idx = listSettings.findIndex(t => t.table == table);
      if (idx == -1) return;
      listSettings[idx] = {
        pageSize: 50,
        hiddenColumns: [],
        table
      }
      this.$store.dispatch('updateSetting', { key: 'listSettings', value: listSettings });
      this.clearedListSettings = true;
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'userSettings', 'User list settings updated', { tableName: table });
    },
    clearAccountCache() {
      this.$store.dispatch('clearAccountCache');
      this.showClearSuccessToast('Account');
    },
    clearRemoteCache() {
      this.$store.dispatch('clearRemoteCache');
      this.showClearSuccessToast('Remote');
    },
    clearDeviceCache() {
      this.$store.dispatch('clearDeviceCache');
      this.showClearSuccessToast('Device');
    },
    clearSubscriptionCache() {
      this.$store.dispatch('clearSubscriptionCache');
      this.showClearSuccessToast('Subscription');
    },
    clearSearchCache() {
      this.$store.dispatch('clearSearchCache');
      this.showClearSuccessToast('Search');
    },
    clearUsageCache() {
      this.$store.dispatch('clearUsageCache');
      this.showClearSuccessToast('Usage');
    },
    showClearSuccessToast(cache) {
      this.$buefy.toast.open({
        duration: 3000,
        message: `${cache} cache cleared successfully.`,
        position: 'is-bottom-left',
        type: 'is-success'
      })
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'clearCache', `${cache} cache cleared successfully.`);
    },
    activeTabClick(tabId) {
      let activeTabName = '';
      switch (tabId) {
        case 0: activeTabName = 'Back'; break;
        case 1: activeTabName = 'Portal Settings'; break;
        case 2: activeTabName = 'Permissions'; break;
        case 3: activeTabName = 'API Clients'; break;
        default: activeTabName = '';
      }
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'tabOpen', `User panel dropdown tab opened`, { tabName: activeTabName });

      this.activeTab = tabId;
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-user-panel-dropdown {
  width: 365px;

  header {
    padding: 0.5rem;
    padding-bottom: 0;
  }

  .kpt-user-panel-details {
    border-top: 1px solid $white-ter;
    
    .kpt-user-panel-content {
      padding: 12px;
    }

    .kpt-user-panel-menu {
      border-top: 1px solid $white-ter;
      border-bottom: 1px solid $white-ter;
      
      .level {
        padding: 12px;
        margin-bottom: 0;
        border-bottom: 1px solid $white-ter;

        &:hover {
          cursor: pointer;
          background-color: $white-ter;
        }

        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }

  .kpt-list-settings, .kpt-clear-cache {
    margin-top: 8px;
  }
}
</style>
